'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { IndividualSidebar } from '../../-components/IndividualSidebar';

/**
 * 照会・参照（lookup）配下の共通レイアウト。
 *
 * portal サイドバー + コンテンツ領域を提供し、配下の全ページ
 * （dashboard / ledger リソース一覧 / 勤怠 / 給与 / 勤務スケジュール）で共有する。
 * 各ページはこの main の中でヘッダー帯 + スクロール領域を描画する。
 */
export const Route = createFileRoute('/_individual/individual/portal/lookup')({
  component: LookupLayout
});
function LookupLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();
  return <div className="flex h-full min-h-0 w-full overflow-hidden">
      {isDesktop && <IndividualSidebar mode="portal" open={sidebarOpen} onToggle={() => setSidebarOpen(v => !v)} />}
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>;
}